import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    Fi25Procesos: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_FI25_PROCESOS = 'GET_ALL_FI25_PROCESOS'
const GET_FI25_PROCESO_BY_ID = 'GET_FI25_PROCESO_BY_ID'
const POST_FI25_PROCESO = 'POST_FI25_PROCESO'
const UPDATE_FI25_PROCESO = 'UPDATE_FI25_PROCESO'
const DELETE_FI25_PROCESO = 'DELETE_FI25_PROCESO'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllFi25Procesos = createAsyncThunk(
    GET_ALL_FI25_PROCESOS,
    async () => {
        try {
            const fullUrl = host + `Fi25anexoProcesos/obtenerAnexosUpProceso`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las Fi25Procesoss: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getFi25ProcesosById = createAsyncThunk(
    GET_FI25_PROCESO_BY_ID,
    async (idFi25Procesos) => {
        try {
            const fullUrl = host + `Fi25anexoProcesos/obteneranexoProcesoById/${idFi25Procesos}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertFi25Procesos = createAsyncThunk(
    POST_FI25_PROCESO,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexoProcesos/agregaranexoProceso`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateFi25Procesos = createAsyncThunk(
    UPDATE_FI25_PROCESO,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexoProcesos/actualizaranexoProceso`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteFi25Procesos = createAsyncThunk(
    DELETE_FI25_PROCESO,
    async (idFi25Procesos) => {
        try {
            const fullUrl = host + `Fi25anexoProcesos/eliminaranexoProceso/${idFi25Procesos}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosFi25ProcesosSlice = createSlice({

    name: 'metodosFi25ProcesosSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllFi25Procesos.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.Fi25Procesos = payload.data.data

        },
        [getFi25ProcesosById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.Fi25Procesos = payload.data.data
        },
        [insertFi25Procesos.fulfilled]: (state, { payload }) => {
            state.Fi25Procesos = payload.data.data
        },

        [updateFi25Procesos.fulfilled]: (state, { payload }) => {

        },
        [deleteFi25Procesos.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosFi25ProcesosSlice.actions
export const Fi25ProcesosReducer = metodosFi25ProcesosSlice.reducer